module.exports = __webpack_public_path__ + "img/view_7.28516416.jpg";